<template>
  <div class="app-container">
    <el-form :model="search" :inline="true" label-position="right" ref="search">
      <el-form-item label="承运商区域(省)" prop="provinceCode">
        <el-select
          v-model="search.provinceCode"
          placeholder="请选择"
          clearable
          style="width: 100%"
          @change="getTblCity"
        >
          <el-option
            v-for="item in provinceList"
            :key="item.provinceCode"
            :label="item.provinceName"
            :value="item.provinceCode"
            style="width: 100%"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="承运商区域(市)" prop="cityCode">
        <el-select
          v-model="search.cityCode"
          placeholder="请选择"
          clearable
          style="width: 100%"
          :disabled="!search.provinceCode"
        >
          <el-option
            v-for="item in cityList"
            :key="item.cityCode"
            :label="item.cityName"
            :value="item.cityCode"
            style="width: 100%"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="是否分配承运商" prop="isAllocate">
        <el-select
          v-model="search.isAllocate"
          placeholder="请选择"
          clearable
          style="width: 100%"
        >
          <el-option
            v-for="(val, key) in isAllocateOPtion"
            :key="key"
            :label="val"
            :value="key"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="承运商名称" prop="partnerName">
        <el-input
          v-model="search.partnerName"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="组织编号" prop="partnershipId">
        <el-input
          v-model="search.partnershipId"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="row-bg">
      <el-button type="primary" size="medium" @click="exportExcel()"
        >导出</el-button
      >
      <el-button type="primary" size="medium" @click="BatchSetCarrierAreaFun"
        >批量分配承运商</el-button
      >
      <el-button type="primary" size="medium" @click="handleSearch()"
        >查询</el-button
      >
      <el-button size="medium" @click="resetForm">重置</el-button>
    </div>
    <el-table
      ref="checktableData"
      :data="list"
      v-loading="listLoading"
      :reserve-selection="true"
      center
      height="60vh"
    >
      <el-table-column label="承运区域(省)" width="150" align="center">
        <template slot-scope="scope">{{ scope.row.provinceName }}</template>
      </el-table-column>
      <el-table-column
        label="承运区域(市)"
        prop="cityName"
        width="150"
      ></el-table-column>
      <el-table-column label="是否分配承运商" prop="isAllocate" width="150">
        <!-- <template slot-scope="scope">{{
          isAllocateOPtion[scope.row.isAllocate]
        }}</template> -->
      </el-table-column>

      <el-table-column label="承运商名称" prop="partnerName"></el-table-column>
      <el-table-column
        label="组织编号"
        prop="partnershipId"
        width="150"
      ></el-table-column>
      <el-table-column label="组织类型" prop="partnershipType" width="150">
        <template slot-scope="scope">{{
          partnershipTypeOption[scope.row.partnershipType]
        }}</template>
      </el-table-column>

      <el-table-column label="操作" fixed="right" width="200" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="setCarrier(scope.row)">分配</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="search.currPage"
        :page-size="search.pageSize"
        :page-sizes="[10, 20]"
        :total="total"
      >
      </el-pagination>
    </div>
    <setCarrierDialog
      ref="setCarrierRef"
      @opera-success="getList"
    ></setCarrierDialog>
    <commonBath
      ref="batchCommonRef"
      @opera-success="getList"
      :errUrl="'/autoapp-default-server-recovery/api/partnerManagementBond/downLoadPartnerAllocateFailInfo'"
      :downloadTemplateUrl="'/autoapp-default-server-recovery/api/partnerManagementBond/exportPartnerAllocateRegion'"
      :importUrl="'/autoapp-default-server-recovery/api/partnerManagementBond/importPartnerAllocateRegion'"
      :title="'批量分配承运商'"
      :uploadTitle="'导入承运商'"
    ></commonBath>
    <!-- <BatchSetCarrierArea
      ref="batchCommonRef"
      @opera-success="getList"
    ></BatchSetCarrierArea> -->
  </div>
</template>
<script>
import setCarrierDialog from "./components/setCarrierDialog";
import commonBath from "./components/commonBath.vue";

import {
  getPartnerRegionList,
  getPartner,
  findAllProvince,
  findAllCity,
} from "@/api/oldForNew";
import { orderStatusOption } from "./mixin.js";

export default {
  name: "carrierArea",
  components: {
    setCarrierDialog,
    commonBath
  },
  filters: {
    changeStatus(value, optionList) {
      return value
        ? (optionList.find((item) => item.value == value) || {}).label || ""
        : "";
    },
  },

  data() {
    return {
      list: [],
      optionList: {},
      total: null, //列表总条数
      listLoading: false,
      createdTime: [], //开始时间
      appointTime: [], //预约时间
      completeTime: [], //完成时间
      warehouseList: [], //归集仓仓库列表
      orderStatusOption: orderStatusOption, //订单状态
      partnershipTypeOption: { 1: "子公司", 2: "合作商", 3: "总公司" }, //当前用户所属组织 1 子公司 2 第三方 3 总公司

      search: {
        provinceCode: "",
        cityCode: "",
        partnershipId: "",
        partnerName: "",
        isAllocate: "",
        currPage: 1,
        pageSize: 10,
      },
      provinceList: [], //省份列表
      cityList: [], //市列表
      isAllocateOPtion: { 0: "已分配", 1: "未分配" }, //是否有待回收旧机
      partnershipType: null, //当前用户所属组织 1 子公司 2 第三方 3 总公司
    };
  },
  async created() {
    this.getTblProvince();
    this.getList();
    // 获取当前账号的组织类型
    this.partnershipType = JSON.parse(localStorage.getItem("partnershipType"));
  },
  methods: {
    handleSearch() {
      this.search.currPage = 1;
      this.getList();
    },
    async getList() {
      let { statusCode, data, total, message } = await getPartnerRegionList(
        this.search
      );
      if (statusCode == 200) {
        this.list = data || [];
        this.total = total || 0;
      } else {
        this.$message.error(message);
      }
    },
    resetForm() {
      this.search = this.$options.data().search;
      this.completeTime = this.appointTime = this.createdTime = [];
    },
    //提交回收单
    setCarrier(row) {
      this.$refs.setCarrierRef.openDialog(row);
    },
    //获取省份列表
    async getTblProvince() {
      this.search.cityCode = "";
      let { statusCode, data } = await findAllProvince();
      if (statusCode === 200) {
        this.provinceList = data;
      }
    },
    //根据省份获取城市列表
    async getTblCity() {
      this.search.cityCode = "";
      if (!this.search.provinceCode) {
        return;
      }
      let { statusCode, data } = await findAllCity(this.search.provinceCode);
      if (statusCode === 200) {
        this.cityList = data;
      }
    },
    //根据省市获取区域列表
    getTblCounty() {
      this.search.county = "";
      return this.HttpService.get(
        `/autoapp-default-server-recovery/api/tbl-county/getTblCounty?city=${this.search.city}`
      ).then((res) => {
        if (res.statusCode === 200) {
          this.countyList = res.data;
        }
      });
    },
    handleSizeChange(val) {
      this.search.currPage = 1;
      this.search.pageSize = val;
      this.getList();
    },
    handleCurrentChange() {
      this.getList();
    },

    //批量分配承运商
    BatchSetCarrierAreaFun() {
      this.$refs.batchCommonRef.openDialog();
    },
    //跳转到详情页
    goDetail(rowData) {
      this.$router.push({
        path: "/oldForNewService/orderDetail",
        query: {
          orderNo: rowData.orderNo,
        },
      });
    },

    //导出
    exportExcel() {
      let url =
        "/autoapp-default-server-recovery/api/partnerManagementBond/exportPartnerAllocateRegion";
      let title = "承运商区域分配列表导出";

      this.HttpService.post(url, this.search).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
        } else {
          this.$message.warning(res.message)
        }
      })
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.goodsStyle {
  display: flex;
  align-items: center;
}
.flex {
  display: flex;
  align-items: center;
  // margin: 0 20px;
  padding: 0 20px;
  span {
    min-width: 100px;
  }
}
.row-bg {
  margin-bottom: 15px;
}
.btnBox {
  margin-bottom: 20px;
}
.data-view-wrap {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-start;
  .item-wrap {
    margin-right: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #00b882;
    padding: 10px;
    height: auto;
    color: #fff;

    .unit {
      margin-left: 20px;
      max-width: 300px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      > span {
        font-size: 20px;
        padding-right: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/carrierArea.vue